// extracted by mini-css-extract-plugin
export default {"card":"Card_card__pSup9","isShadow":"Card_isShadow__es9Bk"};